import { render, staticRenderFns } from "./problemInput.vue?vue&type=template&id=2713aea6&scoped=true"
import script from "./problemInput.vue?vue&type=script&lang=js"
export * from "./problemInput.vue?vue&type=script&lang=js"
import style0 from "./problemInput.vue?vue&type=style&index=0&id=2713aea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713aea6",
  null
  
)

export default component.exports